import script from "./ThePageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ThePageLayout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__